'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_SIZES = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INPUT_SIZES = exports.INPUT_SIZES = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  DEFAULT: 'DEFAULT'
};

var EnterpriseDropDown = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseDropDown, _Component);

  function EnterpriseDropDown() {
    (0, _classCallCheck3.default)(this, EnterpriseDropDown);
    return (0, _possibleConstructorReturn3.default)(this, (EnterpriseDropDown.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseDropDown)).apply(this, arguments));
  }

  (0, _createClass3.default)(EnterpriseDropDown, [{
    key: 'renderOptions',
    value: function renderOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return options.map(function (option) {
        return _react2.default.createElement(
          'option',
          {
            key: 'tq-plus-admin-' + option.id,
            value: option.id
          },
          option.description || option.name
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          children = _props.children,
          size = _props.size,
          fill = _props.fill,
          className = _props.className,
          width = _props.width,
          height = _props.height,
          padding = _props.padding,
          options = _props.options,
          restProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'size', 'fill', 'className', 'width', 'height', 'padding', 'options']);

      var styles = require('./EnterpriseDropDown.scss');

      var inputModifiers = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, styles.small, size === INPUT_SIZES.SMALL), (0, _defineProperty3.default)(_cx, styles.medium, size === INPUT_SIZES.MEDIUM), (0, _defineProperty3.default)(_cx, styles.large, size === INPUT_SIZES.LARGE), (0, _defineProperty3.default)(_cx, styles.default, size === INPUT_SIZES.DEFAULT), (0, _defineProperty3.default)(_cx, styles['width--small'], width === INPUT_SIZES.SMALL), (0, _defineProperty3.default)(_cx, styles['width--medium'], width === INPUT_SIZES.MEDIUM), (0, _defineProperty3.default)(_cx, styles['width--large'], width === INPUT_SIZES.LARGE), (0, _defineProperty3.default)(_cx, styles['height--small'], height === INPUT_SIZES.SMALL), (0, _defineProperty3.default)(_cx, styles['height--medium'], height === INPUT_SIZES.MEDIUM), (0, _defineProperty3.default)(_cx, styles['height--large'], height === INPUT_SIZES.LARGE), (0, _defineProperty3.default)(_cx, styles['padding--small'], padding === INPUT_SIZES.SMALL), (0, _defineProperty3.default)(_cx, styles['padding--medium'], padding === INPUT_SIZES.MEDIUM), (0, _defineProperty3.default)(_cx, styles['padding--large'], padding === INPUT_SIZES.LARGE), (0, _defineProperty3.default)(_cx, styles.fill, fill), _cx));

      return _react2.default.createElement(
        'select',
        (0, _extends3.default)({}, restProps, { className: (0, _classnames2.default)(className, styles.root, inputModifiers) }),
        this.renderOptions(options),
        children
      );
    }
  }]);
  return EnterpriseDropDown;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.node,
  type: _react.PropTypes.string,
  size: _react.PropTypes.string,
  width: _react.PropTypes.string,
  height: _react.PropTypes.string,
  padding: _react.PropTypes.string,
  options: _react.PropTypes.array,
  selected: _react.PropTypes.number,
  fill: _react.PropTypes.bool,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  size: INPUT_SIZES.DEFAULT,
  fill: false
}, _temp);
exports.default = EnterpriseDropDown;


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseDropDown/EnterpriseDropDown.jsx
// module id = 1583
// module chunks = 0